import { MtUser } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { UserFilters } from "client/store"
import * as types from "./types"


export const setTaskParticipantList = (taskParticipantList: types.TaskParticipantList) => ({
    type: inferLiteral(types.TASK_PARTICIPANT_LIST),
    taskParticipantList,
})
export const setNotAssignedTaskParticipantIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_PARTICIPANT_IDS),
    userIds,
})
export const setNotAssignedTaskParticipantSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_PARTICIPANT_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedTaskParticipantFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_PARTICIPANT_FILTERS),
    filters,
})
export const setNotAssignedTaskParticipantSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_PARTICIPANT_SELECTED),
    selected,
})
